import { ChangeDetectionStrategy, Component, computed, forwardRef, input } from "@angular/core";
import { CommonModule, NgComponentOutlet } from "@angular/common";
import { type RisrSchemaDisplayArray } from "./risr-schema-display";
import { RisrSchemaDisplayGroupRenderer } from "./risr-schema-display-group-renderer";

@Component({
    selector: 'risr-schema-display-array-renderer',
    imports: [
        CommonModule,
        NgComponentOutlet,
        forwardRef(() => RisrSchemaDisplayGroupRenderer)
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        @if (field().visible()) {
            @if (widgetComponent()) {
                <ng-container *ngComponentOutlet="widgetComponent(); inputs: { field: field() }"></ng-container>
            } @else {
                <div class="display-array">
                    @for (group of elements(); track group.name) {
                        <div class="display-array__item">
                            <risr-schema-display-group-renderer [field]="group"></risr-schema-display-group-renderer>
                        </div>
                    }
                </div>
            }
        }
    `,
    styles: [`
        .display-array {
            display: grid;
            gap: 0.75rem;
        }
        .display-array__item {
            padding-left: 0.75rem;
            border-left: 2px solid var(--color-gray-200);
        }
    `],
})
export class RisrSchemaDisplayArrayRenderer {
    field = input.required<RisrSchemaDisplayArray>();

    protected readonly widgetComponent = computed(() => this.field().schemaField.options?.widgetComponent);

    protected readonly elements = computed(() => this.field().risrElements || []);
}
